import { useState } from "react";
import { useImpersonation } from "@/contexts/ImpersonationContext";
import { AccessAdminPanel } from "@/components/access-groups/AccessAdminPanel";
import { SystemrollerCard } from "@/components/settings/SystemrollerCard";
import { MenyRekkefolgePanel } from "@/components/settings/MenyRekkefolgePanel";
import { ProsjektrollerCard } from "@/components/settings/ProsjektrollerCard";
import { SnarveierCard } from "@/components/settings/SnarveierCard";
import { SrIcon } from "@/components/ui/SrIcon";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";

type Tab = "sys" | "proj" | "grupper" | "meny";

const TABS: { key: Tab; label: string }[] = [
  { key: "sys", label: "Systemroller" },
  { key: "proj", label: "Prosjektroller" },
  // VIB-2726: grupper hører hjemme her, der roller og tilganger alt bor. Samme
  // komponent rendres også fra arkivinnstillingene (AccessAdminDialog).
  { key: "grupper", label: "Grupper" },
  { key: "meny", label: "Meny & snarveier" },
];

export default function TilgangerSettings() {
  const { activeUser } = useImpersonation();
  const [tab, setTab] = useState<Tab>("sys");
  const canManageSettings =
    activeUser?.role === "admin" || activeUser?.role === "superadmin";

  if (!canManageSettings) {
    return (
      <div className="page-container">
        <p className="text-sm text-muted-foreground">Du har ikke tilgang.</p>
      </div>
    );
  }

  return (
    <div className="page-container animate-fade-in space-y-6">
      <div>
        <h1 className="font-display font-semibold text-[clamp(28px,3vw,40px)] tracking-[-0.01em] flex items-center gap-2">
          <SrIcon name="shield" className="h-6 w-6" />
          Tilganger og roller
        </h1>
        <p className="text-sm text-muted-foreground mt-1">
          Styr hva hver rolle kan se og gjøre — meny-tilgang per systemrolle, og
          Se/Endre-rettigheter per prosjektrolle.
        </p>
      </div>

      {/* VIB-2545: Tabs gir tablist-semantikk og piltaster mellom fanene. */}
      <Tabs value={tab} onValueChange={(v) => setTab(v as Tab)}>
        <TabsList aria-label="Tilganger og roller">
          {TABS.map((t) => (
            <TabsTrigger key={t.key} value={t.key}>
              {t.label}
            </TabsTrigger>
          ))}
        </TabsList>
        <TabsContent value="sys" className="mt-6">
          <SystemrollerCard />
        </TabsContent>
        <TabsContent value="proj" className="mt-6">
          <ProsjektrollerCard />
        </TabsContent>
        <TabsContent value="grupper" className="mt-6">
          <AccessAdminPanel />
        </TabsContent>
        <TabsContent value="meny" className="mt-6 space-y-6">
          <MenyRekkefolgePanel />
          <SnarveierCard />
        </TabsContent>
      </Tabs>
    </div>
  );
}
